/* eslint-disable indent */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { useLocation, useNavigate } from "react-router-dom";
import Moment from "react-moment";
import API from "../../../../api";
import urls from "../../../../api/urls";

import {
  getStartAndEndDate,
  getCreatedDateNEnd,
  dateFormat_dmy,
  dateFormat_ymd,
  capitaliseWithHyphen,
  scrollToTop,
  formatReceiverAddress,
  splitReceiverName,
  capitalize,
} from "../../../../utils";
import {
  Col,
  Row,
  Select,
  Menu,
  Dropdown,
  Spin,
  Input,
  Button,
  message,
  DatePicker,
  Form,
  Divider,
} from "antd";
import { FilterFilled } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";

import { shallowEqual, useDispatch, useSelector } from "react-redux";
import DraggerModal from "../../modals/draggerModal";
// import ViewBookingSummaryEdit from "../../ViewBookingSummaryEdit";
import ViewBookingSummary from "../../../ViewBookingSummary";
import {
  getBarcodeId,
  getSingleBooking,
} from "../../../../actionsMethods/cashBookingMethods";
import { column } from "../commonColumn";
import TableContainer from "../../../../components/TableContainer";
import search_icon from "../../../../assests/images/search-icon.svg";
import truck from "../../../../assests/images/SVG/packetSurface.svg";
import plane from "../../../../assests/images/planeicon.svg";
import print_icon from "../../../../assests/images/master/print.svg";
import print_icon_white from "../../../../assests/images/master/print-white.svg";

// import "./AllBookingTable.scss";
import Smcs_Loader from "../../../../assests/images/loader-new.gif";

import filter_icon from "../../../../assests/images/master/sorting-filter.svg";
import Dox from "../../../ViewBookingSummary/Dox";
import PrintBooking from "../../../PrintBooking";
import Filters from "../Filters";
import useCustomNavigate from "../../../../components/customNavigationHook";
import { convertCurrentToPrevBookingData } from "../../../../utils/bookingDataConverter";
const {
  UPLOAD_MANIFEST_FILE,
  GET_DOCUMENT_DETAILS_BY_AWB,
  GET_ALL_BOOKING_STATUS,
  GET_SINGEL_DOCUMENT_DETAILS_AWB,
  GET_TOTAL_LOAD,
  CANCEL_REATIL_BOOKING,
  GET_CLIENT_LIST_NEW,
  GET_SINGEL_DOCUMENT_DETAILS_AWB_BE,
  GET_DOCUMENT_DETAILS_BY_AWB_CLIENT,
  RESEND_INVOICE,
  LISTING_BOOKING_API,
} = urls;
const { RangePicker } = DatePicker;

const BookingTable = ({
  userList,
  exportData = () => {},
  convertNewToOldData,
  printPDFLabel,
  loading,
  setLoading,
  listingType,
  setTotalCount,
}) => {
  const [form] = Form.useForm();
  const history = useLocation();

  const dispatch = useDispatch();
  const navigate = useCustomNavigate();
  const [data, setData] = useState([]);
  const [oldAwbNum, setOldAwbNum] = useState(null);
  const [uploadModalvisible, setUploadModalvisible] = useState(false);
  // const [inputSearchValue, setInputSearchValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const [bookingType, setBookingType] = useState("");

  const debounceTimeout = useRef(null);
  const backHistory = history?.state?.ocr;

  const [pageNum, setPageNum] = useState(
    backHistory ? history?.state?.pageNo : 0
  );
  const [pageSize, setPageSize] = useState(
    backHistory ? history?.state?.pageSize : 20
  );

  const [currentPage, setCurrentPage] = useState(
    backHistory ? history?.state?.pageNo + 1 : 1
  );

  const [searchValue, setSearchValue] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [filteredInfo, setFilteredInfo] = useState(null);
  const [printer, setPrinter] = useState(null);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [printDoc, setPrintDoc] = useState(null);
  const [printMultiDoc, setPrintMultiDoc] = useState([]);

  const [dateRange, setDateRange] = useState(
    backHistory && history?.state?.startDate
      ? history?.state
      : {
          startDate: moment().format(dateFormat_dmy),
          endDate: moment().format(dateFormat_dmy),
        }
  );

  const selectedCompany =
    JSON.parse(localStorage.getItem("selectedCompany")) || null;

  const componentRef = useRef();
  const [printTrue, setPrintTrue] = useState(false);

  const viewBookingSummaryResponse = useSelector(
    (state) => state.appReducer.getSingleBookingReducer,
    shallowEqual
  );

  const {
    result: singleResult,
    error,
    fetching: loading2,
  } = viewBookingSummaryResponse;

  useEffect(() => {
    const { state } = history || {};

    if (backHistory) {
      setAllFilters({ ...state });
      getAllBookings({ ...state });

      setFilteredInfo({
        travelBy: state?.travelBy ? [state?.travelBy] : [],
        bookingStatus: state?.status ? [state?.status] : [],
        totalCharge: state?.totalCharge ? [state?.totalCharge] : [],
        userName: state?.userSeleted,
        type: [state?.docType, state?.serviceType], // Removes null/undefined values
      });

      // setClientID(state.client);
    }
  }, [history]);
  // console.log(filteredInfo, "FINFO");

  useEffect(() => {
    let temp = {
      pageNo: pageNum,
      pageSize: pageSize,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      search: searchValue,
      bookingType: "retail",
      status: null,
      docType: null,
      serviceType: null,
      travelBy: null,
      client: null,
      userSeleted: null,
    };
    setAllFilters(temp);
    if (!history?.state?.startDate) {
      getAllBookings(temp);
    }
  }, []);

  const userId = JSON.parse(localStorage.getItem("userId"));

  const [allFilters, setAllFilters] = useState({
    pageNo: null,
    pageSize: null,
    startDate: null,
    endDate: null,
    search: null,
    bookingType: "retail",
    status: null,
    docType: null,
    serviceType: null,
    travelBy: null,
    client: null,
    userSeleted: null,
    bulkPrint: null,
  });

  const getAllBookings = async ({
    pageNo,
    pageSize,
    startDate,
    endDate,
    search,
    bookingType = "retail",
    status,
    docType,
    serviceType,
    travelBy,
    client,
    userSeleted,
    bulkPrint,
    totalCharge,
  }) => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setLoading(true);

    let url = "";
    let data = bookingType;

    const startDateNew = moment().subtract(1, "day").format("YYYY-MM-DD");
    const endDateNew = moment().format("YYYY-MM-DD");
    const dateNew = `&startDate=${startDateNew}&endDate=${endDateNew}`;

    url = `${LISTING_BOOKING_API}?` + dateNew;

    if (selectedCompany?.key) {
      url += `&companyId=${selectedCompany?.key}`;
    }

    if (data) {
      url += `&bookingType=${"credit"}`;
    }
    url += `&utm=${listingType}&status=DRAFT`;

    // if (status) {
    //   url += `&status=${
    //     status?.toLowerCase() === "booked" ? "Booked" : capitalize(status)
    //   }`;
    // } else {
    //   url += `&status=${"Booked, Manifested"}`;
    // }

    if (search) {
      url += `&documentNos=${search}`;
    } else {
      url += `&page=${pageNum + 1}&limit=${pageSize}`;
    }

    // if (docType) {
    //   url += `&shipmentType=${docType}`;
    // }

    // if (serviceType) {
    //   url += `&deliveryPromise=${serviceType}`;
    // }

    // if (travelBy) {
    //   url += `&travelBy=${capitalize(travelBy)}`;
    // }

    // if (userSeleted) {
    //   let findUser = userList?.find((item) => item?.value == userSeleted);
    //   url += `&usernames=${findUser?.label}`;
    // }

    let response;

    try {
      if (userSeleted) {
        response = await API.Api(url).getCustomHeader({
          "USER-ID": userSeleted,
          "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
        });
      } else {
        response = await API.Api(url).getWithPremiseHeader();
      }
      if (response?.response?.data?.total && listingType == "API") {
        setTotalCount(response?.response?.data?.total || 0);
      }
      if (response?.status) {
        setLoading(false);
        let res = response?.response?.data;
        let response1Data;

        response1Data = convertNewToOldData({
          data: { items: res.shipments },
        });

        const result = sanitizeData(response1Data);
        console.log(result, "response1Data");

        if (bulkPrint) {
          setSelectedRowKeys(result?.viewBookings?.map((e) => e.awbNumber));
        }

        setData(result);
      } else {
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      message.error(error?.message || "Internal server error.");
    }
  };

  function sanitizeData(obj) {
    for (let key in obj) {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        obj[key] === "" ||
        Number.isNaN(obj[key]) ||
        obj[key] === "NaN" ||
        Number.isNaN(obj[key])
      ) {
        obj[key] = 0;
      }
    }
    return obj;
  }

  const handleUpload = useCallback((val) => {
    setUploadModalvisible(true);
    setOldAwbNum(val.awbNumber);
  });

  function handleCancel() {
    setIsModalOpen(false);
    setIsSummaryModalOpen(false);
  }

  function MyComponent(dateToFormat) {
    return (
      <>
        <Moment format="DD/MM/YYYY">{dateToFormat}</Moment>
        <br />
        <Moment format="hh:mm A">{dateToFormat}</Moment>
      </>
    );
  }

  const currentEnv = process.env.REACT_APP_ENV;

  function handleEditView(params) {
    setBookingType(params?.bookingType);
    setIsModalOpen(true);
    dispatch(getSingleBooking(params?.awbNumber));
    setBookingType(params?.bookingType);
  }

  const handleEyeButton = (b) => {
    setBookingType(b?.bookingType);
    setIsSummaryModalOpen(true);
    if (currentEnv == "qa" || currentEnv == "prod") {
      getDetails(b?.awbNumber);
    } else {
      dispatch(getSingleBooking(b?.awbNumber));
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const statusFun = (val) => {
    const statusColors = {
      BOOKED: "stat-green",
      INITIATED: "blue",
      "In progress": "blue",
      Delivered: "stat-green",
      PACKETED: "darkBlue",
      SCANNED: "purple",
      "In transit": "yellow",
      MANIFESTED: "yellow",
      OUTSCANNED_TO_CP: "yellow",
    };

    const color = statusColors[val?.toUpperCase()] || "yellow";

    return <span className={color}>{val?.toUpperCase()}</span>;
  };

  /******************* Input search ******************************/

  const handleChangeSearch = (e) => {
    let currValue = e.target.value;
    if (currValue && isNaN(currValue)) {
      return;
    }
    setSearchValue(currValue);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      let temp = {
        pageNo: 0,
        pageSize: 20,
        startDate: moment().subtract(30, "days"),
        endDate: moment(new Date(), dateFormat_dmy),
        search: currValue.length ? currValue.trim() : null,
        bookingType: "retail",
        client: null,
        status: null,
        docType: null,
        serviceType: null,
        travelBy: null,
        userSeleted: null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    }, 900);
  };

  /******************* Type ******************************/

  function closeUploadModal(data) {
    setUploadModalvisible(false);
  }

  async function handleOK(data) {
    const temp = data?.map((val) => ({
      fileName: val?.response?.data?.filePath,
      fileId: val?.response?.data?.id,
    }));

    let response = await API.Api(UPLOAD_MANIFEST_FILE).postCustomHeader(temp, {
      "Awb-Number": oldAwbNum,
    });
    if (response) {
      setUploadModalvisible(false);
    }
  }

  function handlePageChange(pagination, filters, sorter) {
    setFilteredInfo(filters);
    window.scrollTo(0, 0);

    setPageSize(pagination?.pageSize);
    setPageNum(pagination?.current - 1);
    setCurrentPage(pagination?.current);

    setSearchValue(null);
    const hasFilters =
      filters?.bookingType?.[0] ||
      filters?.userName?.[0] ||
      filters?.bookingStatus?.[0] || // status
      filters?.type?.[0] ||
      filters?.type?.[1] ||
      filters?.travelBy?.[0] ||
      filters?.totalCharge?.[0];

    if (hasFilters) {
      setFilteredInfo(filters);
      let temp = {
        pageNo: pagination.current - 1,
        pageSize: pagination?.pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        client: null,

        search: null, // search is null

        bookingType: "retail",
        status: filters?.bookingStatus?.[0] || null,
        docType: filters?.type?.[0] || null,
        serviceType: filters?.type?.[1] || null,
        travelBy: filters?.travelBy?.[0] || null,

        userSeleted: filters?.userName?.[0] || null,
        totalCharge: filters?.totalCharge?.[0] || null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    } else {
      let temp = {
        pageNo: pagination?.current - 1,
        pageSize: pagination?.pageSize,
        bookingType: "retail",
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        client: null,

        search: null, // search is null

        status: null,
        docType: null,
        serviceType: null,
        travelBy: null,
        userSeleted: null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    }
  }
  // console.log(allFilters, "allFilters");

  function handleEdit(id, dateNTime, record) {
    localStorage.setItem("side_active", 3);

    const formattedDate = moment(dateNTime).format("DD-MM-YYYY");
    const newId = listingType === "API" ? record?.refDocumentNo : id;

    navigate(
      `/${listingType.toLowerCase()}-bookings/${formattedDate}/${newId}/${listingType}`,
      {
        state: {
          ...allFilters,
          credit: false,
          retail: false,
          ...(listingType === "OCR" ? { ocr: true } : { api: true }),
        },
      }
    );
  }

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  // console.log(filteredInfo, "filteredInfo");

  const handleDateChange = (e, date) => {
    // e.preventDefault();
    setSearchValue(null);

    setDateRange({ startDate: date[0], endDate: date[1] });
    let temp = {
      pageNo: pageNum,
      pageSize,
      startDate: date[0] || moment(new Date(), dateFormat_dmy),
      endDate: date[1] || moment(new Date(), dateFormat_dmy),
      search: null,

      client: null,

      bookingType: "retail",
      status: filteredInfo?.bookingStatus?.[0] || null,
      docType: filteredInfo?.type?.[0] || null,
      serviceType: filteredInfo?.type?.[1] || null,
      travelBy: filteredInfo?.travelBy?.[0] || null,

      userSeleted: filteredInfo?.userName?.[0] || null,
    };
    getAllBookings(temp);
    setAllFilters(temp);
  };

  // console.log(pageSize, "pageSize");

  const cancelBooking = async (awbNumber) => {
    setLoading(true);

    let response = await API.Api(
      CANCEL_REATIL_BOOKING + `${awbNumber}`
    ).deleteHeader();
    if (response?.status) {
      setLoading(false);
      message.success("Booking cancelled successfully");

      getAllBookings(allFilters);
      // handleCancelBooking();
      // setSetsubmitRespons(response);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error.");
    }
  };

  useEffect(() => {
    if (error !== null) {
      setLoading(false);
      message.error("Internal server error");
      return;
    }
    if (singleResult && printTrue) {
      setTimeout(() => {
        setLoading(false);
        printHandle(); // Delayed to ensure the DOM is ready
      }, 100);
    }
  }, [singleResult, error]);

  // const printHandle = useReactToPrint({
  //   content: () => componentRef?.current || null,
  //   onBeforePrint: () => setPrintTrue(false),
  //   onAfterPrint: () => setPrintTrue(false),
  // });

  function printCallBack(params) {
    setPrintTrue(true);
    setLoading(true);
    dispatch(getSingleBooking(params));
  }

  useEffect(() => {
    const fetchPrinter = async () => {
      try {
        // STANDARD PORT FOR ZEBRA PRINTER
        const availablePrinters = await axios.get(
          "http://localhost:9100/available"
        );
        setPrinter(availablePrinters?.data?.printer[0] || null);
        //  REQUEST TO INITIATE PRINTER
        await axios.post("http://localhost:9100/write", "", {
          headers: {
            "Content-Type": "text/plain",
          },
        });
      } catch (err) {
        // console.log("ZEBRA PRINTER NOT FOUND ");
        return;
      }
    };
    if (!printer) {
      fetchPrinter();
    }
  }, []);

  const handlePrinting = async (payload) => {
    let currentShipment = 1;

    // Processed address fields
    const processedAddress = formatReceiverAddress(
      payload?.addressDetails?.receiverAddressLine1,
      payload?.addressDetails?.receiverAddressLine2
    );

    const receiverName = splitReceiverName(
      payload?.addressDetails?.receiverName
    );

    const serviceMap = {
      "FAST TRACK": "FST",
      STANDARD: "STD",
      "VALUE PLUS": "VPLUS",
      VAYUQUICK: "VQ",
      VAYUQUICK_PRO: "VQ PRO",
    };

    const rawService = payload?.serviceDetails?.service?.toUpperCase() || "";

    const speed = serviceMap[rawService] || rawService;

    const baseData = {
      ...receiverName,
      documentNumber: payload?.awbNumber,
      bookingType:
        payload?.shipmentDetails?.type?.toLowerCase() === "dox"
          ? "DOX"
          : "NDOX",
      bookingService: speed,
      bookindTravelType:
        payload?.serviceDetails?.travelBy?.toLowerCase() === "surface"
          ? "SUR"
          : "AIR",
      currentShipment: 1, // Replace this with appropriate logic for currentShipment
      senderName: payload?.shipmentDetails?.clientName,
      receiverMobileNumber: payload?.addressDetails?.receiverMobileNumber,
      receiverCity: payload?.addressDetails?.receiverCity,
      deliveryPincode: payload?.addressDetails?.receiverPincode,
      receiverAddressLine1: processedAddress[0] || "",
      recieverAddressLine2: processedAddress[1] || "",
      recieverAddressLine3: processedAddress[2] || "",
      recieverAddressLine4: processedAddress[3] || "",
      recieverAddressLine5: processedAddress[4] || "",
      recieverAddressLine6: processedAddress[5] || "",
      recieverAddressLine7: processedAddress[6] || "",

      senderAddress:
        payload?.addressDetails?.senderAddressLine1 +
        ", " +
        payload?.addressDetails?.senderCity,
      senderMobileNumber: payload?.addressDetails?.senderMobileNumber || "",
      totalShipments:
        parseInt(payload?.childShipmentDetails?.length || "0") + 1,
    };

    const printData = async (data) => {
      setLoading(true);
      try {
        const updatedTemplate = await fetch("/printingTemplate.txt")
          .then((response) => response?.text())
          .then((res) =>
            res?.replace(/{{(.*?)}}/g, (_, key) => {
              return data[key?.trim()] || "";
            })
          )
          .catch((err) => console.log(err));

        const printingData = JSON.stringify({
          device: printer,
          data: updatedTemplate,
        });

        await axios.post("http://localhost:9100/write", printingData, {
          headers: {
            "Content-Type": "text/plain",
          },
        });
        setLoading(false);
      } catch (err) {
        setLoading(false);
        message.error("UNABLE TO PRINT");
        // console.log(err, "UNABLE TO PRINT");
      }
    };

    // Print for the main payload
    const mainData = {
      ...baseData,
      documentNumber: payload?.awbNumber,
    };

    await printData(mainData);

    // Check and print for child shipments
    if (
      payload?.childShipmentDetails &&
      Array.isArray(payload?.childShipmentDetails) &&
      payload?.childShipmentDetails?.length > 0
    ) {
      for (const child of payload.childShipmentDetails) {
        currentShipment = currentShipment + 1;
        const childData = {
          ...baseData,
          documentNumber: child?.childAwbNumber,
          currentShipment: currentShipment,
        };
        await printData(childData);
      }
    }
  };

  const printerCallBack = async (params) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB + +params}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      // setLoading(false);
      handlePrinting(response?.response?.data);
      // setTotalLoad(response?.response?.data);
    } else {
      setLoading(false);

      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const clearFilters = () => {
    setFilteredInfo(null);
    let temp = {
      pageNo: 0,
      pageSize: 20,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      search: null,
      bookingType: "retail",

      status: null,
      docType: null,
      serviceType: null,
      travelBy: null,
      userSeleted: null,
      totalCharge: null,
    };
    setAllFilters(temp);
    getAllBookings(temp);
  };

  const setLoadTable = (val) => {
    setLoading(val);
  };

  const printHandle = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      setLoading(true);
    },
    onAfterPrint: () => {
      setLoading(false);
    },
    onPrintError: () => {
      setLoading(false);
      console.error("An error occurred while printing.");
    },
  });

  const creditPrint = (id) => {
    setPrintMultiDoc([]);
    setLoading(true);
    setPrintDoc(id);
  };

  const resendInvoice = async (documentNo, phoneNo) => {
    setLoading(true);
    let payload = {
      phoneNo: phoneNo,
      documentNo: documentNo,
    };
    const response = await API.Api(RESEND_INVOICE).post(payload);

    if (response.status) {
      // const data = await response.json();
      setLoading(false);
      message.success("Invoice resent successfully!");
    } else {
      setLoading(false);
      message.error(data?.message || "Failed to resend invoice.");
    }
  };

  const [documentDetails, setDocumentDetails] = useState([]);

  const getDetails = async (id) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB_BE + +id}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      let extract = response?.response?.data?.data?.items;
      let convert = convertCurrentToPrevBookingData(extract);
      setDocumentDetails(convert);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };
  const disableInvoice = true;
  const disableTotalCharge = true;
  const disableActionButton = true;
  const enableViewBookingButton = true;

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="print-only">
        <Dox
          // componentRef={componentRef}
          bookingType={bookingType}
          allAppData={
            currentEnv == "qa" || currentEnv == "prod"
              ? documentDetails
              : singleResult
          }
        />
      </div>
      <ViewBookingSummary
        loading={loading2}
        visible={isSummaryModalOpen}
        // handleCancelBooking={handleCancelBooking}
        handleCancel={handleCancel}
        allAppData={
          currentEnv == "qa" || currentEnv == "prod"
            ? documentDetails
            : singleResult
        }
        bookingType={bookingType}
        componentRef={componentRef}
      />

      <DraggerModal
        oldAwbNum={oldAwbNum}
        visible={uploadModalvisible}
        handleCancel={closeUploadModal}
        handleOk={handleOK}
      />

      <div className="table-container master-main-container">
        <Row
          className="row-one align-center"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div style={{ margin: "6px 0px" }}>
            <RangePicker
              value={
                dateRange.startDate && dateRange.endDate
                  ? [
                      moment(dateRange.startDate, dateFormat_dmy),
                      moment(dateRange.endDate, dateFormat_dmy),
                    ]
                  : null
              }
              format={dateFormat_dmy}
              onClick={(e) => e.stopPropagation()}
              disabledDate={(current) => disabledDate(current)}
              onChange={handleDateChange}
              // format={dateFormat_dmy}
              className="input-field-style"
              style={{ width: "225px" }}
            />
          </div>

          <Col span={4} style={{ marginLeft: "auto", marginRight: "9px" }}>
            <Input
              value={searchValue}
              placeholder="Search by doc No."
              bordered
              maxLength={16}
              onChange={(e) => handleChangeSearch(e)}
              style={{
                borderRadius: "5px",
                height: "30px",
                fontSize: "12px",
                marginRight: "10px",
              }}
              suffix={<img src={search_icon} />}
            />
          </Col>

          <Button
            style={{ height: "28px" }}
            type="primary"
            onClick={() => {
              //navigate("/multi-print-booking", { state: selectedRowKeys })
              exportData(allFilters);
            }}
            className="btn-style"
            // disabled={selectedRowKeys.length === 0}
          >
            <img src={print_icon_white} /> <b>&nbsp;EXPORT</b>
          </Button>
        </Row>
        <TableContainer
          // rowKey={(record) => record?.awbNumber}
          // rowSelection={rowSelection}
          onChange={handlePageChange}
          columns={column(
            MyComponent,
            statusFun,
            handleEdit,
            handleEditView,
            handleUpload,
            handleEyeButton,
            pageSize,
            pageNum + 1,
            cancelBooking,
            printCallBack,
            printerCallBack,
            printPDFLabel,
            filteredInfo,
            clearFilters,
            setLoadTable,
            creditPrint,
            resendInvoice,
            userList,
            disableInvoice,
            disableTotalCharge,
            disableActionButton,
            enableViewBookingButton,
            listingType
          )}
          scroll={{ x: 800 }}
          // showTotal={(total, range) =>
          //   `${range[0]}-${range[1]} of ${total} items`
          // }
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: data?.totalCount,
            itemRender: itemRender,
            pageSizeOptions: ["20", "50", "100"],
            showSizeChanger: true,
          }}
          dataSource={data?.viewBookings}
          headerClassName="header"
          className="view-table table-head-sticky"
        />
      </div>
    </Spin>
  );
};

export default React.memo(BookingTable);
